import { AUTHORIZING_STATUS, type WorkspaceSummary } from '@coworker/contracts';

import { useSession } from './use-session.js';

/**
 * Which workspace this person is working in - WEB-005, EMP-006.
 *
 * **The first workspace is not the same as the first usable one, and that gap
 * was a live defect.** `AppShell` named `workspaces[0]`, but only an `ACTIVE`
 * membership authorizes anything (`AUTHORIZING_STATUS`) - the session
 * deliberately carries `INVITED` and `SUSPENDED` ones too, so the SPA can show a
 * pending invitation. A person whose first workspace was an unaccepted
 * invitation saw its name in the header while every request made with its id
 * came back 403 `WORKSPACE_FORBIDDEN`.
 *
 * One hook rather than the same `find` in two screens: WEB-006 turns this into a
 * switcher, and when it does, this is the only file that changes.
 *
 * `undefined` means "no workspace this person may act in", which is a real state
 * - an invitation that has not been accepted - and not a loading state.
 */
export function useCurrentWorkspace(): WorkspaceSummary | undefined {
  const { query } = useSession();
  return query.data?.workspaces.find((workspace) => workspace.status === AUTHORIZING_STATUS);
}
